<template>
  <div data-test="saved-filters" class="saved-filters">
    <section v-if="savedFilters?.length > 0">
      <SavedFiltersTable class="d-block-md" />

      <mc-modal v-if="isMobile" :heading="$t('filter.savedFilters')" :open="showModal" @closed="modalToggle(false)">
        <span class="mb-2 mt-2 mds-headline--small"> {{ $t("common.clickToApply") }} </span>
        <SavedFiltersTable />
      </mc-modal>

      <DeleteFilter :filter-name="deleteFilterName" :index="deleteFilterIndex" />
    </section>

    <p v-else class="saved-filters__empty" data-test="saved-filters-no-saved-filters">
      {{ $t("filter.savedFilterDescription") }}
    </p>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { filters } from "@/store/filters";
import DeleteFilter from "@/components/modals/DeleteFilter.vue";
import SavedFiltersTable from "@/components/filters/SavedFiltersTable.vue";
import emitter from "tiny-emitter/instance";

export default {
  name: "SavedFilters",
  components: { DeleteFilter, SavedFiltersTable },
  data() {
    return {
      filterList: [],
      deleteFilterIndex: null,
      deleteFilterName: null,
      showModal: true
    };
  },
  computed: {
    ...mapState(filters, ["savedFilters"]),
    isMobile() {
      return window.matchMedia("(max-width: 700px)").matches;
    }
  },
  async mounted() {
    if (!this.savedFilters?.length) {
      await this.getSavedFilters();
    }
  },
  methods: {
    ...mapActions(filters, ["getSavedFilters"]),
    modalToggle(value) {
      this.showModal = value;
      emitter.emit("toggle-saved-filters");
    }
  }
};
</script>
